// Open the standalone full-window Aladin sky viewer (public/aladin-sky.html) in a
// new tab, passing a file's IVOA ObsCore footprint (s_region polygon + s_fov) so
// it centers/zooms on the field and overlays the footprint + SIMBAD/Gaia catalogs.
// Shared by the user ObservationDetail page and the operator floating-window
// EmbeddedObservationDetail. No-ops when the file has no footprint.
export function openSkyView(file) {
  if (!file || !file.s_region) return;
  const params = new URLSearchParams();
  params.set('region', file.s_region);
  if (file.s_fov != null) params.set('fov', String(file.s_fov));
  if (file.target_ra != null) params.set('ra', String(file.target_ra));
  if (file.target_dec != null) params.set('dec', String(file.target_dec));
  const name = file.file_name || file.filename || (file.file_path ? file.file_path.split('/').pop() : '');
  if (name) params.set('name', name);
  window.open(`/aladin-sky.html?${params.toString()}`, '_blank', 'noopener');
}
